import type { ComponentProps } from 'react';

type ArrowRightProps = ComponentProps<'svg'> & { color?: string };
const ArrowRight = ({ color = '#EE4F5E', ...props }: ArrowRightProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        stroke={color}
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M1.667 10.5h16.666"
      />
      <path
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="m12.5 4.667 5.833 5.833-5.833 5.833"
      />
    </svg>
  );
};

export default ArrowRight;
